import React, { Component } from "react";
import { message, Table, Tag } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import { ModalItem, ButtonItem, dineroDisabledMask } from "../../../../Components/Items";
import moment from "moment";

class SeleccionarXmlModal extends Component {
  state = {
    loading: false,
    archivosXml: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarXmls();
    }
  }

  async consultarXmls() {
    this.setState({ loading: true, archivosXml: [] });
    try {
      const res = await axios.post(
        "descargaMasiva/selectXmlProveedor",
        {
          empresaId: this.props.empresaId,
          rfc: this.props.proveedorRfc,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        this.setState({ archivosXml: res.data.data || [] });
      } else {
        message.error("No se pudieron cargar los archivos XML");
      }
    } catch {
      message.error("Error al cargar los archivos XML");
    } finally {
      this.setState({ loading: false });
    }
  }

  async seleccionar(id) {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "descargaMasiva/datosXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        this.props.onSelect({
          fileName: res.data.uuid,
          fileData: JSON.stringify(res.data.dataXml),
        });
      } else {
        message.error("No se pudo obtener el XML");
      }
    } catch {
      message.error("Error al obtener el XML");
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const columns = [
      {
        title: "Serie / Folio",
        width: "15%",
        render: (_, r) => {
          const val = [r.serie, r.folio].filter(Boolean).join(" - ");
          return val || "—";
        },
      },
      {
        title: "Emisor",
        dataIndex: "emisorNombre",
        width: "28%",
      },
      {
        title: "Fecha",
        dataIndex: "fecha",
        width: "13%",
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "—"),
      },
      {
        title: "Subtotal / Total",
        width: "20%",
        align: "right",
        render: (_, r) => (
          <div>
            <div style={{ fontSize: 12, color: "#888" }}>
              {dineroDisabledMask(r.subtotal)}
            </div>
            <div style={{ fontWeight: 600 }}>{dineroDisabledMask(r.total)}</div>
          </div>
        ),
      },
      {
        title: "Estado",
        width: "10%",
        render: (_, r) =>
          r.estado === 0 ? (
            <Tag color="red">Cancelada</Tag>
          ) : (
            <Tag color="green">Vigente</Tag>
          ),
      },
      {
        title: "",
        width: "14%",
        render: (_, r) => (
          <ButtonItem
            type="primary"
            size="small"
            disabled={r.estado === 0}
            onClick={() => this.seleccionar(r._id)}
          >
            Usar
          </ButtonItem>
        ),
      },
    ];

    return (
      <ModalItem
        title={
          "Seleccionar XML del Proveedor" +
          (this.props.proveedorRfc ? " (" + this.props.proveedorRfc + ")" : "")
        }
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.props.onCancel}
        paddingTop
        width={960}
      >
        <Table
          dataSource={this.state.archivosXml}
          columns={columns}
          rowKey="_id"
          size="small"
          pagination={{ pageSize: 10 }}
          locale={{
            emptyText: "No se encontraron facturas XML de ingreso de este proveedor",
          }}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(SeleccionarXmlModal);
